import { CommonError } from '../../types';
import { Contest } from '../contest/types';
import { FETCH_RANKS_FAILURE, FETCH_RANKS_REQUEST, FETCH_RANKS_SUCCESS } from './constants';
import { RankResponse } from './types';

export interface FetchRankRequestAction {
    type: typeof FETCH_RANKS_REQUEST;
    payload: Contest;
}

export interface FetchRankSuccessAction {
    type: typeof FETCH_RANKS_SUCCESS;
    payload: RankResponse;
}

export interface FetchRankFailureAction {
    type: typeof FETCH_RANKS_FAILURE;
    payload: CommonError;
}

export type RankActions = FetchRankRequestAction | FetchRankSuccessAction | FetchRankFailureAction;

export const fetchRankRequest = (payload: Contest): FetchRankRequestAction => ({
    type: FETCH_RANKS_REQUEST,
    payload,
});

export const fetchRankSuccess = (rankResponse : RankResponse): FetchRankSuccessAction => ({
    type: FETCH_RANKS_SUCCESS,
    payload: rankResponse,
});

export const fetchRankFailure = (error: CommonError): FetchRankFailureAction => ({
    type: FETCH_RANKS_FAILURE,
    payload: error,
});
